'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { useTranslation } from '@/hooks/useTranslation';

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-primary/10 via-background to-accent/10">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-headline font-bold text-foreground mb-6">
          {t('ctaTitle')}
        </h2>
        <p className="text-xl text-muted-foreground mb-10 max-w-3xl mx-auto leading-relaxed">
          {t('ctaSubtitle')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            href="/manufacturer-directory"
            className="inline-flex items-center gap-2 px-8 py-4 bg-conversion text-conversion-foreground rounded-md text-lg font-headline font-semibold hover:bg-conversion/90 transition-colors duration-200 shadow-md"
          >
            {t('browseManufacturers')}
            <Icon name="ArrowRightIcon" size={20} variant="outline" />
          </Link>
          <Link
            href="/product-catalog"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-md text-lg font-headline font-semibold hover:bg-primary/90 transition-colors duration-200 shadow-md"
          >
            {t('exploreProducts')}
            <Icon name="MagnifyingGlassIcon" size={20} variant="outline" />
          </Link>
        </div>

        <div className="mt-12 pt-12 border-t border-border">
          <p className="text-sm text-muted-foreground mb-6">{t('trustedBy')}</p>
          <div className="flex flex-wrap justify-center gap-8 items-center">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="BuildingOfficeIcon" size={20} variant="outline" />
              <span className="text-sm">{t('fortune500')}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="UserGroupIcon" size={20} variant="outline" />
              <span className="text-sm">{t('smeManufacturers')}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="GlobeAltIcon" size={20} variant="outline" />
              <span className="text-sm">{t('internationalTraders')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
